import React, { useContext, useEffect, useState } from 'react';
import { GlobalContext, GlobalContextType } from '../context/GlobalContext';
import { signInWithPassword } from '../supabase/supabase';
import { redirect, useNavigate } from 'react-router';
import { Button, Alert } from 'react-bootstrap'

function LoginForm({}) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const global = useContext(GlobalContext)
  const navigate = useNavigate()

  useEffect(() => {
    console.log(global.session)
    if (global.session) {
      navigate("/dashboard")
    }
  })
  
  const handleSubmit = async (e:React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');
    
    try {
      const auth = await signInWithPassword(email, password);
      
      if (auth.error) {
        throw auth.error;
      }
      
      global.setSession(auth.data.session);
      localStorage.setItem("session", JSON.stringify(auth.data.session));
      global.setUser(auth.data.user);
      
      if (auth.data.session) {
        navigate("/dashboard");
      }
    } catch (err: any) {
      setError(err.message || 'Login failed. Please check your credentials.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="modern-auth-form">
      {error && <Alert variant="danger" className="auth-error">{error}</Alert>}
      
      <div className="form-group">
        <input
          type="email" 
          id="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          className="modern-input"
          placeholder="Email address"
        />
      </div>
      
      <div className="form-group">
        <input
          type="password"
          id="password" 
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          className="modern-input"
          placeholder="Password"
        />
        <div className="forgot-password">
          <a href="/forgot-password" className="forgot-link">Forgot password?</a>
        </div>
      </div>
      
      <Button 
        type="submit"
        disabled={isLoading}
        className="modern-submit-btn"
        size="lg"
      >
        {isLoading ? 'Signing in...' : 'Sign In'}
      </Button>
    </form>
  );
}

export default LoginForm;
